import { faCheck, faExclamation, faInfo, faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styled from "styled-components"


const types = {
    error: { icon: faXmark, primary: "#c2185b", secondary: "#fce4ec"},
    warning: { icon: faExclamation, primary: "#f57c00", secondary: "#fff3e0"},
    success: { icon: faCheck, primary: "#388e3c", secondary: "#e8f5e9"},
    info: { icon: faInfo, primary: "#0288d1", secondary: "#e1f5fe"},
    default: { icon: null, primary: "#616161", secondary: "#f5f5f5"}
}

const S = {
    RootContainer: styled.div`
        display: ${props => props.visible ? "flex" : "none"};
        flex-flow: row;
        min-height: 2rem;
        flex: 1;
        font-size: .85rem;
        padding: ${props => props.large ? "1em calc(1.25em - .25rem)" : ".5em calc(1em - .25rem)"};
        background-color: ${props => props.secondary};
        border-left: .25rem solid ${props => props.primary};
        color: ${props => props.primary};
    `,
        IconContainer: styled.div`
            display: flex;
            margin: auto;
            position: relative;
            bottom: .05em;
            padding: 0 .5em;
            font-size: 1rem;
            width: 1em!important;

            @media screen and (max-width: 480px) {
                margin: auto 0;
                min-width: 2em;
            }
        `,
            Icon: styled.span`
                font-size: 1rem;
                margin: 2px auto auto auto;
            `,
        TextContainer: styled.div`
            display: flex;
            flex-flow: column;
            flex: 1 1;
            margin: auto;
            padding: 0 .5em;
        `,

}

export const Notice = (props) => {
    return ( 
        <>
            <S.RootContainer primary={types[props.type]?.primary || types['default'].primary} secondary={types[props.type]?.secondary || types['default'].secondary} visible={props.visible} fillWidth={props.fillWidth} large={props.large}>
                <S.IconContainer hide={props.hideIcon}>
                    <S.Icon>
                        <FontAwesomeIcon icon={types[props.type]?.icon || types['default'].icon} />
                    </S.Icon>
                </S.IconContainer>
                <S.TextContainer>
                    {props.children || props.description}
                </S.TextContainer>
            </S.RootContainer>
        </>
    )
}